// Single place for the product name. Rename by setting REACT_APP_APP_NAME at build time.
export const APP_NAME = process.env.REACT_APP_APP_NAME || "Kindamorrow";
export const APP_NAME_UPPER = APP_NAME.toUpperCase();
// Public contact address; override with REACT_APP_CONTACT_EMAIL.
export const CONTACT_EMAIL = process.env.REACT_APP_CONTACT_EMAIL || "hello@kindamorrow.com";
